import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FeatureFlagContainer, SetGlobalStyle, EmptyState } from '@vezeeta/web-components';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import EnterpriseLayout from '@vezeeta/enterprise-layout';
import { connect } from 'react-redux';
import { MixpanelConsumer } from 'react-mixpanel';
import { Flex } from 'grid-styled';
import '@vezeeta/enterprise-modals/lib/Modal.scss';
import { language } from '@vezeeta/enterprise-store/lib/types/language';
import { withTranslation } from 'app/withTranslation/withTranslation';
import { USER_PRIVILEGES, getRoleBasedAccess } from 'app/RoleBasedAccess';
import { ServicesList, AddService, EditService } from 'app/Routes';
import '@vezeeta/web-components/lib/shared/Utils.scss';
import {
  getFeatureFlags,
  getbreadCrumbSteps,
  isSupportSingleLanguage,
  getCurrencyLocalizedName,
} from './App.helper';
import { extendContentContainer } from './App.style';

class App extends Component {
  constructor(props) {
    super(props);
    SetGlobalStyle();
  }

  render() {
    const { user, isUserLoaded, clinics, localization, countries } = this.props;
    let supportSingleLanguage = true;
    let localizedCurrency = '';

    if (!localizedCurrency && countries && countries.length && user) {
      localizedCurrency = getCurrencyLocalizedName(countries, user.CountryId, language);
    }

    supportSingleLanguage = isSupportSingleLanguage(user, isUserLoaded);
    const roledBasedAccessCatalogue = getRoleBasedAccess();
    const canAccessPatientsWeb =
      roledBasedAccessCatalogue.services.canView === USER_PRIVILEGES.AUTHORIZED;
    return (
      <FeatureFlagContainer.Provider value={getFeatureFlags()}>
        <Router>
          <EnterpriseLayout
            supportSingleLanguage={supportSingleLanguage}
            breadcrumbProps={getbreadCrumbSteps(localization)}
            activeTab="Services"
            extendContentContainer={extendContentContainer}
          >
            <React.Fragment>
              <input hidden type="text" id="user-form" value="true" readOnly />
              {!canAccessPatientsWeb && (
                <Flex
                  justifyContent="center"
                  alignItems="center"
                  css={{
                    height: '500px',
                  }}
                >
                  <EmptyState
                    image={`${process.env.REACT_APP_CDN_URL}/assets/safe.svg`}
                    text={localization && localization.notAutherized}
                  />
                </Flex>
              )}
              {isUserLoaded && localization && canAccessPatientsWeb ? (
                <MixpanelConsumer>
                  {mixpanel => (
                    <Switch>
                      <Route
                        path="/"
                        exact
                        render={routeProps => (
                          <ServicesList
                            {...routeProps}
                            {...this.props}
                            mixpanel={mixpanel}
                            supportSingleLanguage={supportSingleLanguage}
                            clinics={clinics}
                            localization={localization}
                            language={language}
                            localizedCurrency={localizedCurrency}
                          />
                        )}
                      />
                      <Route
                        path="/addService"
                        exact
                        render={routeProps => (
                          <AddService
                            {...routeProps}
                            {...this.props}
                            mixpanel={mixpanel}
                            supportSingleLanguage={supportSingleLanguage}
                            clinics={clinics}
                            localization={localization}
                            language={language}
                            localizedCurrency={localizedCurrency}
                          />
                        )}
                      />
                      <Route
                        path="/edit-service"
                        exact
                        render={routeProps => (
                          <EditService
                            {...routeProps}
                            {...this.props}
                            mixpanel={mixpanel}
                            supportSingleLanguage={supportSingleLanguage}
                            clinics={clinics}
                            localization={localization}
                            language={language}
                            localizedCurrency={localizedCurrency}
                          />
                        )}
                      />
                    </Switch>
                  )}
                </MixpanelConsumer>
              ) : (
                ''
              )}
            </React.Fragment>
          </EnterpriseLayout>
        </Router>
      </FeatureFlagContainer.Provider>
    );
  }
}

const mapStateToProps = state => ({
  isUserLoaded: state.user.loaded,
  user: state.user.user,
  countries: state.country.Countries,
  clinics: state.clinics.Clinics,
});

App.propTypes = {
  isUserLoaded: PropTypes.bool.isRequired,
  user: PropTypes.object,
  clinics: PropTypes.array,
  localization: PropTypes.object,
};

export default withTranslation(
  connect(
    mapStateToProps,
    null,
  )(App),
);
